var ComparePage = (function ($) {

    var getPDPLink = function (elem) {
        var cellIndex = elem.closest("td").index();

        return elem.closest(".table").find("tr:first-child")
            .find("td:eq(" + cellIndex + ") .comparison-top-actions a.comparison-product-link")
            .attr("href");
    };

    function init() {
        if (!$(".comparisonProductsDetailsPage").length) {
            return;
        }
        if(IsMobile.any()) {
            var clientsReviews = $(".client-reviews-rating-section .product-list-client-reviews-rating-stars-container");
            if (clientsReviews.length) {
                clientsReviews.css("pointer-events", "none");
            }
        }

        $(".client-reviews-rating-section").on('click', function (event) {
            event.preventDefault();
            var link = getPDPLink($(this));
            if (link === undefined) {
                return;
            }
            link += "#clients-reviews-tab";
            window.location.href = link;
        });
    }
    return {
        init: init
    };

})($);

$(function () {
    ComparePage.init();
});